import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import { FC, useState } from "react";
import {
  addCaseCreation,
  editCaseCreation,
  editCountDefendantList,
} from "services/caseServices";
import { CaseCreation, InvestigationFile } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandler, errorHandlerOnForm } from "utils/helper";

type Props = {
  file: InvestigationFile;
  caseData: CaseCreation;
  onClose: (refetch: boolean) => void;
};

const ArticleOfChangeForm: FC<Props> = ({ file, caseData, onClose }) => {
  const { showTooltip } = useTooltip();
  const { loginData } = useAuth();
  const [loading, setLoading] = useState(false);

  const [reason, setReason] = useState<string>("");
  const [count, setCount] = useState<string>("");

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose(false);
    }
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">
          Article of Change
        </h2>
        <p className="text-xs text-gray-500">
          Are you sure you want to make changes to this article?
        </p>

        <div className="flex flex-col mt-4 w-full">
          <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
            Count
          </label>
          <select
            className="border capitalize border-gray-300 rounded-lg bg-[#F2F2F2] p-2 pr-8 focus:outline-none focus:ring focus:ring-blue-300"
            value={count ?? ""}
            onChange={(e) => setCount(e?.target?.value)}
          >
            <option value={""}>Select Count</option>
            {(caseData?.counts || [])?.map((c) => (
              <option key={c?.id} value={c?.id}>
                Count #{c?.count_number}
              </option>
            ))}
          </select>
        </div>
        <div className="flex flex-col mt-2 w-full">
          <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
            Reason
          </label>
          <textarea
            rows={4}
            placeholder="Enter reason ..."
            className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
            value={reason || ""}
            onChange={(e) => setReason(e.target.value as unknown as string)}
          />
        </div>

        <div className="mt-4 flex justify-between gap-2">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
            onClick={() => {
              onClose(false);
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                        font-[Poppins] cursor-pointer font-[500] w-full
                        text-base rounded-md hover:bg-white hover:text-[#E90101]
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              editCaseCreation({
                id: caseData?.id,
                // is_article_of_cahrge_changed: true,
                reason_for_articel_of_charge: reason,
              })
                .then(() => {
                  editCountDefendantList({
                    id: count,
                    is_article_of_cahrge_changed: true,
                  });

addCaseCreation({
                     id: caseData?.id,
                     is_RTD: caseData?.is_RTD,
                     prosecutor_registration_number:
                       caseData?.prosecutor_registration_number,
                     date_sent_to_prosecutor: caseData?.date_sent_to_prosecutor,
                     estimated_day_to_finish: caseData?.estimated_day_to_finish,
                     investigation_files: [file?.id],
                     status: "Pending",
                     incident_registration_no:
                       caseData?.incident_registration_no,
                     crime_refernce_number: caseData?.crime_refernce_number,
                     crime_type: file?.crime_type,
admin_unit_id: loginData?.admin_unit || "",
                      org_id: loginData?.org_unit || "",
                     assigned_prosecutor_name: loginData?.full_name || "",
                     assigned_prosecutor_userid: loginData?.user_id || "",
                     relation_type: "original",

                     count_number: count,
                   } as unknown as CaseCreation);
                  setLoading(false);
                  showTooltip("Changed Successfully!", "success");
                  setReason("");
                  onClose(true);
                })
                .catch((error) => {
                  setLoading(false);

                  showTooltip(
                    error?.response?.data?.detail ||
                      errorHandlerOnForm(error) ||
                      errorHandler(error) ||
                      "Something went wrong. Please try again.",
                    "error"
                  );
                });
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                {LoadingIcon}
                Loading...
              </div>
            ) : (
              "Change"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArticleOfChangeForm;
